import React from 'react'
import styles from './styles.module.scss'

export function DeletionPolicyRender() {
  return (
    <div className={styles.termsTemplate}>
      <p className={styles.lastUpdate}>
        Última atualização: 12 de setembro de 2025
      </p>

      <div className={styles.space}>
        <p>
          A <strong>RESALE TECNOLOGIA S.A. (“RESALE”)</strong>, CNPJ nº
          21.129.873/0001-79, editou esta Política para explicar de forma clara
          como você pode solicitar a{' '}
          <strong>exclusão de seus dados pessoais</strong>, em conformidade com
          a Lei Geral de Proteção de Dados (LGPD – Lei 13.709/2018).
        </p>

        <p>
          Esta Política aplica-se ao tratamento de dados realizado pela Resale
          no site institucional (
          <a href="www.resale.com.br" target="_blank">
            www.resale.com.br
          </a>
          ), na Plataforma Pagimovel® e nos portais parceiros operados em modelo
          white label.
        </p>
      </div>

      <div>
        <div className={styles.space}>
          <h2 className={styles.spaceTop}>1. DIREITO DE EXCLUSÃO</h2>
          <p>
            Você pode solicitar a exclusão de seus dados pessoais tratados pela
            Resale, nos termos do art. 18, VI, da LGPD.
          </p>
          <p>
            A exclusão implica também a exclusão do seu cadastro na Plataforma,
            o que pode impedir novos acessos e o uso de funcionalidades
            vinculadas.
          </p>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>2. COMO SOLICITAR A EXCLUSÃO</h2>

          <p>
            O pedido deve ser feito por meio do e-mail do Encarregado (DPO):
            <a href="mailto:dpo@resale.com.br">dpo@resale.com.br</a>.
          </p>

          <p>
            Para sua segurança, a Resale poderá solicitar informações adicionais
            para confirmar sua identidade antes de processar a exclusão.
          </p>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>3. PRAZO DE ATENDIMENTO</h2>

          <p>
            A Resale responderá às solicitações em até 15 dias, conforme art. 19
            da LGPD, empregando os melhores esforços para concluir a exclusão em
            prazo menor sempre que possível.
          </p>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>4. LIMITAÇÕES À EXCLUSÃO</h2>

          <p>
            A exclusão poderá não ser imediata ou integral quando houver
            necessidade de manutenção dos dados para:
          </p>

          <ol type="a">
            <li>
              cumprimento de obrigações legais ou regulatórias, como prazos
              fiscais e tributários (ex.: guarda de notas fiscais por 5 anos);
            </li>
            <li>
              exercício regular de direitos em processos judiciais,
              administrativos ou arbitrais (ex.: preservação de registros para
              defesa em ações);
            </li>
            <li>
              execução de contratos vigentes, até sua completa finalização;
            </li>
            <li>
              prevenção de fraudes ou segurança de operações em transações
              imobiliárias, por prazos compatíveis com riscos regulatórios.
            </li>
          </ol>

          <p>
            Nesses casos, os dados serão bloqueados, mantidos apenas para as
            finalidades acima, e eliminados após o término da obrigação ou prazo
            legal.
          </p>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>
            5. DIFERENÇA ENTRE EXCLUSÃO, BLOQUEIO E ANONIMIZAÇÃO
          </h2>

          <ul>
            <li>
              <span className={styles.underline}>Exclusão:</span> remoção dos
              dados pessoais, impossibilitando sua utilização.
            </li>
            <li>
              <span className={styles.underline}>Bloqueio:</span> retenção
              temporária com restrição de acesso, para cumprir obrigação legal
              ou proteger direitos.
            </li>
            <li>
              <span className={styles.underline}>Anonimização:</span> processo
              que retira a possibilidade de associação do dado a uma pessoa
              natural identificada ou identificável.
            </li>
          </ul>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>6. ALTERAÇÕES DESTA POLÍTICA </h2>

          <p>
            Esta Política poderá ser atualizada a qualquer tempo para refletir
            mudanças legais ou operacionais. A nova versão será publicada com
            data de atualização.
          </p>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>7. CANAL DE CONTATO (DPO)</h2>

          <p>
            Encarregada (DPO):{' '}
            <a href="mailto:dpo@resale.com.br">dpo@resale.com.br</a>
          </p>
        </div>
      </div>

      <p className={styles.version}>DOR035 - v3.0 - 20250912</p>
    </div>
  )
}
